import apiAsync from 'infrastructure/shared/api/api-async'

export type ObjectType = {
  uuid_Objectclass: string
}

export type FetchObjectByIdResponse = {
  success: boolean
  message: string
  data: {
    object: ObjectType
  }
}

export const fetchObjectById = (
  objectUuid: string | undefined,
  showLoading = true
): Promise<FetchObjectByIdResponse> => {
  return apiAsync.requestSync({
    endpoint: 'msPlatform',
    path: `objects/${objectUuid}`,
    method: 'GET',
    showLoading: showLoading
  })
}
